import { render, staticRenderFns } from "./PhTextbox.vue?vue&type=template&id=36cfdd5e"
import script from "./PhTextbox.vue?vue&type=script&lang=js"
export * from "./PhTextbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports